<template>
  <div>
    <div v-if="showSignin">
      <signin/>
    </div>
    <div v-else className="pt-50">
      <missingSessionID/>
    </div>
  </div>
</template>
<style>
.pt-50 {
  padding-top: 50px;
}
</style>
<script>
import signin from './SignIn.vue'
import missingSessionID from './InvalidSession.vue'

export default {
  name: "DefaultView",
  components: {
    signin,
    missingSessionID
  },
  data() {
    return {
      showSignin: false,
      query: null,
    }
  },
  mounted() {
    this.query = this.$route.query
    this.isShowSignIn()
  },
  methods: {
    isAuthValueAvailable() {
      const authKeys = this.$cookies.get("casAuthKey");
      return !(authKeys == undefined || authKeys == "");
    },
    isShowSignIn() {
      if (
          this.isAuthValueAvailable()
      ) {
        this.showSignin = true
        return
      }
      this.showSignin = false
    },
  }
}
</script>